export class GlobalConstants {
  public static summarerWinterInfiltrations: string[] = [
    "Semi-tight",
    "Tight",
    "Average",
    "Semi-Loose",
    "Loose",
  ];

  public static fanTypes: string[] = ["PSC", "ECM/ICM", "Other"];
  public static compressorTypes: string[] = ["Single-speed", "Two-speed", "Variable-speed"];
  public static fanSpeedMode: string[] = ["Low", "Medium", "High"];
  public static Edit: string = "Edit";
  public static Copy: string = "Copy";
  public static New: string = "New";

  public static Auth = {
    metadata: "https://rhv2.com.metadata",
  };
  public static ProgressBar = {
    color: "primary",
    mode: "determinate",
    bufferValue: 75,
  };

  public static APIError = {
    ErrorGettingDesignerCompany: "Error in Getting Designer Company",
    ErrorDisplayingDesingerCompany: "Error in Displaying Designer Company",
    ErrorGettingDesignerName: "Error in Getting Designer Name",
    ErrorDisplayingDesingerName: "Error in Displaying Designer Name",
    ErrorGettingDesingDetails: "Error in Getting Design Details",
    ErrorGettingSeasons: "Error in Getting Seasons",
  };

  public static CoolingSizingLimit = {
    Single_Speed:'Single-Speed: Recommended: 90-115% Allowed: 90-130% (Condition A)',
    Two_Speed:'Two-Speed: Recommended: 90-120% Allowed: 90-140% (Condition A)',
    Variable_Speed:'Variable-Speed: Recommended: 90-130% Allowed: 90-160% (Condition A)',
    Designer_Verified:'Designer Verified',
    Check_please:'Please check 4.15'
  }

  public static HeatSizingLimit = {
    Used_for_heating_Only: 'Used for heating Only: 100-140%',
    Paired_With_Cooling:'Paired With Cooling: Recommended: 100-140% Allowed 100-400%',
    Designer_Verified:'Designer Verified',
    Check_please:'Please check 4.21'
  }
}
